<div class="valuation-filter">
  <div
    *ngIf="
      loading &&
      ((activePanel === panel.key && refreshCurrentPanel) ||
        activePanel !== panel.key)
    "
  >
    <va-custom-skeleton
      [customSkeletonConfig]="customSkeletonConfig"
    >
    </va-custom-skeleton>
  </div>
  <ng-container *ngIf="(!loading || (activePanel == panel.key && !refreshCurrentPanel)) && data" >
    <div  class="ratio-section">
      <div class="dd-container">
        <span class="label-and-select">
          <span class="label">Valuation Ratio</span>
          <nz-select
            nzPlaceHolder="Select a ratio"
            [ngModel]="selected_ratio"
            (ngModelChange)="onDropdownChange($event)"
            class="ratio">
            <nz-option
              *ngFor="let ratio of data.ratio_list"
              [nzValue]="ratio.key"
              [nzLabel]="ratio.label"
            ></nz-option>
          </nz-select>
        </span>
        <span class="label-and-select">
          <span class="label">Period</span>
          <nz-select
            nzPlaceHolder="Select a period"
            [ngModel]="selected_year"
            (ngModelChange)="onDropdownChange($event)"
            class="ratio">
            <nz-option
              *ngFor="let year of data.year_list"
              [nzValue]="year.key"
              [nzLabel]="year.label"
            ></nz-option>
          </nz-select>
        </span>
      </div>
      
      <div class="slider-section">
        <!-- <app-graph-slider
          [xSeries]="data.ratio"
          [ySeries]="data.no_of_companies"
          [min]="data.min"
          [max]="data.max"
          label="Value"
          [magnitude]="data.magnitude"
          [currency]="data.currency"
          [selectedMin]="(filter && filter.selected_min)|| data.min"
          [selectedMax]="(filter && filter.selected_max) || data.max"
          (onSelectionChange)="onValueChange($event)"
        ></app-graph-slider> -->
        <app-pharma-slider-filter
          label="Value"
          [showLabel]="true"
          [min]="minValue"
          [max]="maxValue"
          step="1"
          [selectedMin]="selected_min"
          [selectedMax]="selected_max"
          [magnitude]="data.magnitude"
          [currency]="data.currency"
          [isDisabled]="data.isDisabled"
          [valueFormatter]="amountFormatter"
          (onSelectionChange)="onValueChange($event)"
        ></app-pharma-slider-filter>
      </div>
    </div>
  </ng-container>
</div>